export type VehicleAuditCreated = {
  id: string;
  vehicleId: string;
  vehicleAuditState: VehicleAuditState;
};

enum VehicleAuditState {
  IN_PROGRESS = 'in_progress',
  FINISHED_AUDIT = 'finished_audit',
  TO_REVISION = 'to_revision',
}
